import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useXbmGetLoggedInUserDataQuery } from './getUserData.generated';
import { setSentryUserInfo } from '../../utils/sentry.js';

import { PageLoading, PageError } from '@layout/Page';
import { captureException } from '@src/utils/sentry';

export const AppContext = React.createContext(null!);
export const AppContextConsumer = AppContext.Consumer;

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error(
      'You need a AppContextProvider wrapping the current tree on order to access this context',
    );
  }

  return context;
};

const AppContextProvider = ({
  language = null,
  featureSwitches = [],
  children,
}) => {
  const { formatMessage } = useIntl();
  const {
    loading: loadingUser,
    data: userData,
    error: userError,
  } = useXbmGetLoggedInUserDataQuery();

  if (loadingUser) return <PageLoading />;

  if (userError) return <PageError />;

  const currentUser = { ...userData.viewer, featureSwitches };

  // Not logged, should redirect to login but was not done on index.js ???
  if (currentUser && !currentUser.xingId) {
    captureException(new Error(formatMessage({ id: 'XSS_NO_SESSION_ERROR' })));

    return <PageError />;
  }

  setSentryUserInfo({
    id: currentUser.xingId?.id,
    email: currentUser.accountSettings?.email?.active,
  });

  const numberOfBriefings =
    userData.erecruitingSourcingServiceBriefingList.total;

  return (
    <AppContext.Provider
      value={{
        data: { currentUser, language, numberOfBriefings },
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
